import React, { useContext, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { UserContext } from '../userContext/UserContext';
import './logout.css';

const Logout = () => {
    const { instance } = useMsal();
    const { setIsAuthenticated, setUserName, setUserId, setRole } = useContext(UserContext);

    useEffect(() => {
        let isLogoutCalled = false;

        const performLogout = async () => {
            if (isLogoutCalled) {
                console.warn('Logout already in progress...');
                return;
            }
            isLogoutCalled = true;

            try {
                console.log('Clearing local session...');
                localStorage.removeItem('userName');
                localStorage.removeItem('userId');
                localStorage.removeItem('role');
                setIsAuthenticated(false);
                setUserName('');
                setUserId('');
                setRole('');

                console.log('Calling MSAL logoutRedirect...');
                await instance.logoutRedirect({
                    postLogoutRedirectUri: 'https://oil.spm-automation.com/signin',
                });
            } catch (error) {
                console.error('Error during logout:', error);
            }
        };

        performLogout();
    }, [instance, setIsAuthenticated, setUserName, setUserId, setRole]);

    return <div className='logout'>Logging out...</div>;
};

export default Logout;
